import { IHttpService } from "../HttpService";
import RequestType, { IRequestType } from "../../model/request/RequestType";
import { parseBooleanValue, formatBooleanValue } from "../..";
import Request, { IRequest } from "../../model/request/Request";

export interface IRequestService {
  getRequestTypes(): Promise<IRequestType[]>;
  createRequestType(requestType: IRequestType): Promise<any>;
  updateRequestType(requestType: IRequestType): void;
  getApplicantRequests(reportingPeriodApplicantId: number): Promise<IRequest[]>;
  createRequest(request: IRequest): Promise<any>;
  updateRequest(request: IRequest): Promise<any>;
  getRequests(applicantId: number): Promise<any>;
  markReportAsRead(request: IRequest): Promise<any>;
}

const RequestService = (httpService): IRequestService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/";
  const _basePath = "request-types";
  const _baseRequestsPath = "requests";
  const _applicantsPath = "applicant";
  const _readPath = "read";

  const RequestTypeMapper = (json = []) => {
    return json.map((item: any) => {
      let reuqestType = RequestType(item);
      reuqestType.valid = formatBooleanValue(item.valid);
      return reuqestType;
    });
  };

  const RequestMapper = json => {
    return (json || []).map(item => {
      let request = Request(item);
      request.valid = formatBooleanValue(item.valid);
      request.read = formatBooleanValue(item.read);
      return request;
    });
  };

  let ParamsMapper = (requestType: IRequestType) => {
    return {
      name: requestType.name,
      code: requestType.code,
      valid: parseBooleanValue(requestType.valid)
    };
  };
  let RequestParamsMapper = (data: IRequest) => {
    return {
      ...data,
      valid: parseBooleanValue(data.valid),
      read: parseBooleanValue(data.read)
    };
  };

  return {
    async getRequestTypes() {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return RequestTypeMapper(responseJSON);
    },

    async createRequestType(requestType: IRequestType) {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.post(path, {
        params: ParamsMapper(requestType)
      });
      return _http.toText(response);
    },

    async updateRequestType(requestType: IRequestType) {
      const path = _http.buildPath(_baseUrl, _basePath, requestType.code);
      const response = await _http.put(path, {
        params: ParamsMapper(requestType)
      });
      return _http.toText(response);
    },

    async getApplicantRequests(reportingPeriodApplicantId: number) {
      const path = _http.buildPath(_baseUrl, _baseRequestsPath);
      const response = await _http.get(path, {
        query: {
          reportingPeriodApplicantId
        }
      });
      const responseJSON = await _http.toJSON(response);
      return RequestMapper(responseJSON);
    },
    async createRequest(request: IRequest) {
      const path = _http.buildPath(_baseUrl, _baseRequestsPath);
      const response = await _http.post(path, {
        params: RequestParamsMapper(request)
      });
      return _http.toText(response);
    },

    async updateRequest(request: IRequest) {
      const path = _http.buildPath(
        _baseUrl,
        _baseRequestsPath,
        request.id.toString()
      );
      const response = await _http.put(path, {
        params: RequestParamsMapper(request)
      });
      return _http.toText(response);
    },

    async getRequests(applicantId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _baseRequestsPath,
        _applicantsPath,
        applicantId.toString()
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return RequestMapper(responseJSON);
    },

    async markReportAsRead(request: IRequest) {
      const path = _http.buildPath(
        _baseUrl,
        _baseRequestsPath,
        request.id.toString(),
        _readPath
      );
      const response = await _http.put(path);
      return _http.toText(response);
    }
  };
};

export default RequestService;
